import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AuthInterceptor, AuthModule, LogLevel, StsConfigHttpLoader, StsConfigLoader, StsConfigStaticLoader } from "angular-auth-oidc-client";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { LocalizePipe } from './localization/localize.pipe';
import { LoginComponent } from './login/login.component';
import { ApiErrorInterceptor } from "./error/api-error.interceptor";
import { ApiCommunicationInterceptor } from "./loading/api-communication.interceptor";
import { EnvironmentService } from './environment/environment.service';
import { map } from 'rxjs';
import { environment } from '../../environments/environment';

export const authConfigFactory = (environmentService: EnvironmentService) => {
  const config$ = environmentService.cmlConfigOservable$
    .pipe(
      map((env: any) => {
        return {
          logLevel: environment.production ? LogLevel.Error : LogLevel.Warn,
          authority: env.openid.authority,
          redirectUrl: env.baseUrl + '/account/login',
          postLogoutRedirectUri: env.baseUrl + '/account/login',
          clientId: env.openid.clientid,
          scope: 'openid profile email IdentityServer StrukturaUcetniJednotkyService '+
           'PublicGW InternalGW ETLService UcetniDenikService UctovyRozvrhService UcetniDimenzeService HlavniKnihaService '+
           'IntelliBookingService DefiniceVykazuService VysledekVypoctuVykazuService VysledekVypoctuVykazuService SestavenyVykazService '+
           'BankovniPrikazService PlatbyVypisyService PokladnaService',
          responseType: 'code',
          silentRenew: true,
          useRefreshToken: true,
          secureRoutes: [env.api.baseUrl + '/api', env.api.pubgw + '/api']
        };
      })
    );

  return new StsConfigHttpLoader(config$);
};

@NgModule({
  declarations: [
    LocalizePipe,
    LoginComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    AuthModule.forRoot({
      loader: {
        provide: StsConfigLoader,
        useFactory: authConfigFactory,
        deps: [EnvironmentService],
      }
    })
  ],
  exports: [
    LocalizePipe
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ApiErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ApiCommunicationInterceptor, multi: true }
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule')
  }
}

export function throwIfAlreadyLoaded(parentModule: any, moduleName: string) {
  if (parentModule) {
    throw new Error(`${moduleName} has already been loaded. Import CORE only in the AppModule`)
  }
}
